<template>
  <div>
    <div v-if="componentExists(fieldProperties.class)">
      <component
          v-bind:is="fieldProperties.class"
          v-model="innerValue"
          :field-properties="fieldProperties"
          :error-messages="errorMessages"
      />
    </div>
    <div v-else>
      No field custom implementation for "{{ fieldProperties.class }}"
    </div>
  </div>
</template>
<script>
import UnitNerisId from '@/components/Neris/Controls/UnitNerisId';

export default {
  name: 'CustomField',

  components: {
    UnitNerisId,
  },

  props: {
    value: {
      default: '',
    },
    fieldProperties: {
      type: Object,
      required: true,
    },
    errorMessages: {
      type: [Object, Array],
      required: true,
    },
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    componentExists(componentName) {
      return Object.prototype.hasOwnProperty.call(
        this.$options.components,
        componentName,
      );
    },
  },
};
</script>
<style>

</style>
